var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "vx-card",
        { staticClass: "mb-4" },
        [
          _c("validation-observer", {
            ref: "validator",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var valid = ref.valid
                  return [
                    _c(
                      "b-form",
                      {
                        class: [_vm.inline ? "gap-2 items-center" : ""],
                        attrs: { inline: _vm.inline },
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.createOrUpdate.apply(null, arguments)
                          },
                          reset: function ($event) {
                            $event.preventDefault()
                            return _vm.clearForm.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("subscription.user"),
                            rules: "required",
                            slim: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (validationContext) {
                                  return [
                                    _c("select-suggestion", {
                                      class: _vm.user
                                        ? "flex-grow"
                                        : "flex-grow required",
                                      attrs: {
                                        id: "user_id",
                                        column: "name,email",
                                        model: "User",
                                        label: _vm.$t("subscription.user"),
                                        appendClearOption: !_vm.isEdit,
                                        isDisabled: _vm.isEdit,
                                        itemTextFormat:
                                          _vm.formatUserNameEmailHtml,
                                        "dropdown-options-class":
                                          "user-suggest-dropdown",
                                        placeholderText:
                                          "Digite o nome ou e-mail do usuário",
                                        state:
                                          _vm.getValidationState(
                                            validationContext
                                          ),
                                      },
                                      model: {
                                        value: _vm.user,
                                        callback: function ($$v) {
                                          _vm.user = $$v
                                        },
                                        expression: "user",
                                      },
                                    }),
                                    _c(
                                      "b-form-invalid-feedback",
                                      { class: [{ absolute: _vm.inline }] },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              validationContext.errors[0]
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          staticClass: "flex-grow mt-2",
                          attrs: {
                            name: _vm.$t("subscription.plan"),
                            rules: "required",
                            slim: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("subscription.plan"),
                                          "label-for": "subscription_plan_id",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-select",
                                          {
                                            staticClass: "required-select",
                                            attrs: {
                                              id: "subscription_plan_id",
                                              options: _vm.planOptions,
                                              label: "name",
                                              reduce: function (opt) {
                                                return opt.id
                                              },
                                              required: true,
                                              disabled: _vm.isEdit,
                                            },
                                            model: {
                                              value:
                                                _vm.model.subscription_plan_id,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "subscription_plan_id",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "model.subscription_plan_id",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "no-options" },
                                                slot: "no-options",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "subscription.no_plans"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { class: [{ absolute: _vm.inline }] },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  validationContext.errors[0]
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("validation-provider", {
                          staticClass: "flex-grow",
                          attrs: {
                            name: _vm.$t("subscription.status"),
                            rules: "required",
                            slim: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (validationContext) {
                                  return [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("subscription.status"),
                                          "label-for": "status",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-select",
                                          {
                                            staticClass: "required-select",
                                            attrs: {
                                              id: "status",
                                              options: _vm.statusOptions,
                                              label: "label",
                                              reduce: function (opt) {
                                                return opt.value
                                              },
                                              required: true,
                                            },
                                            model: {
                                              value: _vm.model.status,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "status",
                                                  $$v
                                                )
                                              },
                                              expression: "model.status",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "no-options" },
                                                slot: "no-options",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "subscription.no_statuses"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "b-form-invalid-feedback",
                                          { class: [{ absolute: _vm.inline }] },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  validationContext.errors[0]
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        !_vm.isEdit && _vm.requiresPagBankCard
                          ? _c("div", { staticClass: "vx-row w-full" }, [
                              _c("div", { staticClass: "vx-col w-full mb-2" }, [
                                _c("p", { staticClass: "text-sm text-grey" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "subscription.manual_gateway_help"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                              !_vm.user || !_vm.user.id
                                ? _c(
                                    "div",
                                    { staticClass: "vx-col w-full mb-2" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-sm text-warning" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "subscription.manual_gateway_select_user_first"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm.loadingUserCards
                                ? _c(
                                    "div",
                                    { staticClass: "vx-col w-full mb-2" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-sm text-grey" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.loading"))
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : !_vm.pagBankEligibleCards.length
                                ? _c(
                                    "div",
                                    { staticClass: "vx-col w-full mb-2" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "text-sm text-warning" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "subscription.manual_gateway_no_pagbank_cards"
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-6/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "subscription.credit_card"
                                          ),
                                          rules: "required",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "subscription.credit_card"
                                                        ),
                                                        "label-for":
                                                          "credit_card_id",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-select",
                                                        {
                                                          staticClass:
                                                            "required-select w-full",
                                                          attrs: {
                                                            id: "credit_card_id",
                                                            options:
                                                              _vm.pagBankEligibleCards,
                                                            label: "card_label",
                                                            reduce: function (
                                                              opt
                                                            ) {
                                                              return opt.id
                                                            },
                                                            placeholder: _vm.$t(
                                                              "subscription.credit_card_placeholder"
                                                            ),
                                                            clearable: true,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.model
                                                                .credit_card_id,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.model,
                                                                "credit_card_id",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "model.credit_card_id",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "no-options",
                                                              },
                                                              slot: "no-options",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "subscription.manual_gateway_no_pagbank_cards"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-form-invalid-feedback",
                                                        {
                                                          attrs: {
                                                            state:
                                                              _vm.getValidationState(
                                                                validationContext
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                              !_vm.isEdit &&
                              _vm.requiresPagBankCard &&
                              _vm.user &&
                              _vm.user.id &&
                              _vm.pagBankEligibleCards.length
                                ? _c(
                                    "div",
                                    { staticClass: "vx-col sm:w-6/12 w-full" },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: _vm.$t(
                                            "subscription.card_security_code"
                                          ),
                                          rules: "required",
                                          slim: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (validationContext) {
                                                return [
                                                  _c(
                                                    "b-form-group",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "subscription.card_security_code"
                                                        ),
                                                        "label-for":
                                                          "card_security_code",
                                                      },
                                                    },
                                                    [
                                                      _c("b-form-input", {
                                                        staticClass: "w-full",
                                                        attrs: {
                                                          id: "card_security_code",
                                                          type: "password",
                                                          autocomplete: "off",
                                                          state:
                                                            _vm.getValidationState(
                                                              validationContext
                                                            ),
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.model
                                                              .card_security_code,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.model,
                                                              "card_security_code",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "model.card_security_code",
                                                        },
                                                      }),
                                                      _c(
                                                        "b-form-invalid-feedback",
                                                        {
                                                          attrs: {
                                                            state:
                                                              _vm.getValidationState(
                                                                validationContext
                                                              ),
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                validationContext
                                                                  .errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "vx-row" }, [
                          _c(
                            "div",
                            { staticClass: "vx-col sm:w-6/12 w-full" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("subscription.started_at"),
                                    "label-for": "started_at",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-full",
                                    attrs: {
                                      id: "started_at",
                                      type: "datetime-local",
                                    },
                                    model: {
                                      value: _vm.model.started_at,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "started_at", $$v)
                                      },
                                      expression: "model.started_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "vx-col sm:w-6/12 w-full" },
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: _vm.$t("subscription.ends_at"),
                                    "label-for": "ends_at",
                                  },
                                },
                                [
                                  _c("b-form-input", {
                                    staticClass: "w-full",
                                    attrs: {
                                      id: "ends_at",
                                      type: "datetime-local",
                                    },
                                    model: {
                                      value: _vm.model.ends_at,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "ends_at", $$v)
                                      },
                                      expression: "model.ends_at",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "b-form-row",
                          {
                            class: [
                              "justify-end mt-2",
                              _vm.inline ? "ml-auto" : "",
                            ],
                          },
                          [
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      disabled:
                                        !valid ||
                                        _vm.subscriptionPagBankIncomplete,
                                      type: "submit",
                                      variant: "primary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("subscription_plan.save")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      type: "reset",
                                      variant: "outline-secondary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("subscription_plan.reset")
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { cols: "auto" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "float-right",
                                    attrs: { variant: "outline-secondary" },
                                    on: { click: _vm.goBack },
                                  },
                                  [
                                    _c("feather-icon", {
                                      staticClass: "mr-50",
                                      attrs: { icon: "CornerUpLeftIcon" },
                                    }),
                                    _c(
                                      "span",
                                      { staticClass: "align-middle" },
                                      [_vm._v(_vm._s(_vm.$t("back")))]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }